export enum LoginComponentContext {
  default = "default",
  headerModal = "headerModal",
  cartModal = "cartModal",
}
